<template>
    <div class="w100">
        <article class="wContent center modify" style="padding: 10px 0 1px 0">
            <div class="modify-part-1 bgWhite">
                <div class="p10 font14">
                    <!-- <a href="javascript:;" class="inlineBlock" :class="{active: priceParentType == 1}" @click="changePriceParentType(1)">我的定制</a> -->
                    <a href="javascript:;" class="inlineBlock" :class="{active: priceParentType == 2}" @click="changePriceParentType(2)">全部报价</a>
                </div>
                <div class="p15" style="height: 20px; overflow: hidden; position: relative;">
                    <span class="el-icon-arrow-down font18 pointer" style="position: absolute; right: 10px; top: 18px;" @click="showAllPriceParent"></span>
                    <a href="javascript:;" class="inlineBlock" :class="{active: priceType == 0}" @click="changePriceType(0, '')" style="margin-bottom: 10px" v-show="priceParentType == 2">最新</a>
                    <span v-for="(item, index) in list_data" :key="index">
                        <a v-show="item.productName.indexOf('测试') < 0" href="javascript:;" class="inlineBlock" :class="{active: priceType == item.groupPid}" @click="changePriceType(item.groupPid, item.productName)" style="margin-bottom: 10px">{{ item.productName }}</a>
                    </span>
                </div>
            </div>

            <el-row :gutter="20" class="mw-modular-box">
                <el-col :span="16" v-show="!isShowDefault">
                    <div v-if="adIDsIndex[4] && adIDsIndex[4]['list']">
                        <a v-for="(item, index) in adIDsIndex[4]['list']" :key="index" :href="item.adLink" target="_blank" class="w100 block" style="margin-bottom: 20px">
                            <img :src="item.adPicturePath" alt="" class="w100">
                        </a>
                    </div>
                    <div class="bgWhite p10 textRight">
                        <!-- 搜索部分 start -->
                        <div class="mw-search-box">
                            <div class="mw-search-keybox inlineBlock">
                                <el-input placeholder="搜索" v-model="keyword" clearable @blur="changeParam()"></el-input>
                            </div>
                            <div class="mw-search-daybox inlineBlock">
                                <el-date-picker v-model="date" type="date" value-format="yyyy-MM-dd" @change="changeParam()" :clearable="false"></el-date-picker>
                                <span class="value">日期</span>
                            </div>
                            <!-- <a class="mw-search-madebox inlineBlock font16 pointer" @click="goCustomized">
                                <i class="el-icon-sold-out" style="padding-right: 10px"></i>
                                报价定制
                            </a> -->
                        </div>
                        <!-- 搜索部分 end -->
                        <!-- 列表部分1 start -->
                        <div 
                            v-loading="loading"
                            element-loading-text="拼命加载中"
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(255, 255, 255, 1)"
                        >
                            <div class="modify-part-2 p10" style="min-height: 1160px;" v-show="msg_list.length > 0">
                                <div class="part-main textLeft" v-for="(item, index) in msg_list" :key="index">
                                    <span class="part-date font18 fontNormal">{{ item.date}}, {{ item.week }}</span>
                                    <div v-for="(cItem, cIndex) in item.list" :key="cIndex">
                                        <div class="part-list bgGrey">
                                            <el-row>
                                                <el-col :span="3">
                                                    <div class="grid-content part-list-time font18 textCenter">
                                                        {{ cItem.time }}
                                                    </div>
                                                </el-col>
                                                <el-col :span="21">
                                                    <div class="part-list-main font14">
                                                        {{ cItem.info }}
                                                    </div>
                                                    <div class="part-list-type">
                                                        <a href="javascript:;" class="inlineBlock textRight" @click="goCustomized()">{{ cItem.pz }}+</a>
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </div>
                                        <div class="mw-modular-box" v-show="cIndex * (index+1) == 4 && adIDsIndex[2] && adIDsIndex[2]['list'].length > 0">
                                            <a :href="adIDsIndex[2] ? ( adIDsIndex[2]['list'].length > 0 ? adIDsIndex[2]['list'][0]['adLink'] : '') : ''" target="_blank">
                                                <img :src="adIDsIndex[2] ? (adIDsIndex[2]['list'].length > 0 ? adIDsIndex[2]['list'][0]['adPicturePath'] : '') : ''" alt="" style="height: 80px;" class="w100">
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <el-pagination background  @current-change="handleCurrentChange" :current-page="pagenum" :page-size="pernum" :page-sizes="[10, 30, 50]" @size-change="handleChangeSize" layout="total, sizes, prev, pager, next, jumper" :total="totalNum"></el-pagination>
                            </div>
                            <div style="min-height: 1255px;" class="textCenter font14 p20" v-show="msg_list.length == 0">暂无数据~</div>
                        </div>
                        <!-- 列表部分1 end -->
                    </div>
                </el-col>
                
                <el-col :span="16" v-show="isShowDefault">
                    <div class="grid-content bgWhite textCenter font18" style="height: 923px; padding-top: 100px; line-height: 40px;">
                        您暂未定制任何报价信息哦！<br>
                        <router-link to="/home/customized" class="fontRed">点我去定制</router-link>吧
                    </div>
                </el-col>
                
                <el-col :span="8">
                    <div class="grid-content">
                        <div v-if="adIDsIndex[3] && adIDsIndex[3]['list']">
                            <a v-for="(item, index) in adIDsIndex[3]['list']" :key="index" :href="item.adLink" target="_blank" class="w100 block" style="margin-bottom: 20px">
                                <img :src="item.adPicturePath" alt="" class="w100">
                            </a>
                        </div>

                        <RecordAnalysis></RecordAnalysis>

                        <MapControl class="mw-modular-box"></MapControl>

                        <div class="mw-modular-box" v-show="adIDsIndex[0] && adIDsIndex[0]['list'].length > 0">
                            <a :href="adIDsIndex[0] ? ( adIDsIndex[0]['list'].length > 0 ? adIDsIndex[0]['list'][0]['adLink'] : '') : ''" target="_blank">
                                <img :src="adIDsIndex[0] ? (adIDsIndex[0]['list'].length > 0 ? adIDsIndex[0]['list'][0]['adPicturePath'] : '') : ''" alt="" style="height: 80px;" class="w100">
                            </a>
                        </div>

                        <HotRecord :ad="adIDsIndex[1] ? ( adIDsIndex[1]['list'].length > 0 ? adIDsIndex[1]['list'][0]['adPicturePath'] : '') : ''" :link="adIDsIndex[1] ? ( adIDsIndex[1]['list'].length > 0 ? adIDsIndex[1]['list'][0]['adLink'] : '') : ''"></HotRecord>
                        
                    </div>
                </el-col>
            </el-row>
        </article>
        <ConcatsControl></ConcatsControl>
        <Login ref="loginDialog"></Login>
    </div>
</template>

<script>
import ConcatsControl from '../../templates/concatsControl'
import RecordAnalysis from '../../templates/recordAnalysis'
import MapControl from '../../templates/mapControl'
import HotRecord from '../../templates/hotRecord'
import Login from '../../templates/loginControl'
import $ from 'jquery'
import '../../assets/js/gVerify'
import { baseUrl, adIDs, getQueryString, mw_validate } from '../../assets/js/common'
export default {
    name: 'ModifyPrice',
    components: { RecordAnalysis, MapControl, HotRecord, ConcatsControl, Login },
    data () {
        return {
            loading: true,
            adIDsIndex: [],
            token_cyw: '',
            userInfo: {},
            isShowDefault: false, // 无数据时的页面
            priceParentType: 2,
            priceType: 0,
            priceTypeName: '',
            list_data: [],
            keyword: '',
            date: '',
            msg_list: [],
            pagenum: 1,
            pernum: 10,
            totalNum: 0,
        }
    },
    mounted () {
        // 初始化内容
		var time = new Date();
		this.date = `${time.getFullYear()}-${time.getMonth() + 1}-${time.getDate()}`;
        this.priceType = getQueryString('type') ? getQueryString('type') : 0;
        this.getProductTreeList();
        this.getAdByAdp();
    },
    methods: {
        //页面操作
        // 获取广告信息
        getAdByAdp () {
            const self = this;
            self.adIDsIndex = [{
                name: 'indexRight1',
                id: adIDs['indexRight1'],
                list: []
            }, {
                name: 'indexRight2',
                id: adIDs['indexRight2'],
                list: []
            }, {
                name: 'tj45',
                id: adIDs['tj45'],
                list: []
            }, {
                name: 'tjright1',
                id: adIDs['tjright1'],
                list: []
            }, {
                name: 'tjleft1',
                id: adIDs['tjleft1'],
                list: []
            }];
            self.adIDsIndex.forEach((item, index) => {
                self.$get(`${baseUrl.cyw}/industriaAD/getAdByAdp?adpId=${item.id}`, {}).then(res => {
                    if (res.code == 0) {
                        self.adIDsIndex[index]['list'] = res.data;
                    }
                })
            })
        },

        // 查询全部报价分类
        getProductTreeList () {
            const self = this;
            self.$get(`${baseUrl.crm}/business/cyw/openapi/getProductTreeList.json`, {}).then(res => {
                if (res.code == 200) {
                    self.list_data = res.data;
                    self.priceType = 0;
                    self.getMsgInfo();
                } else {
                    self.$message.error('查询分类信息失败');
                }
            }).catch(error => {
                self.$message.error('查询分类信息失败')
            })
        },

        // 根据报价分类获取信息
        getMsgInfo () {
            const self = this;
            self.loading = true;
            let edate = '';
            if (self.date != '') {
                let time = new Date(self.date).getTime() + 86400000;
                time = new Date(time);
                edate = `${time.getFullYear()}-${time.getMonth() + 1}-${time.getDate()}`
            }
            $.ajax({
                url: `${baseUrl.modify}/API_V1/API_MSGBYMSSQL/MSG_INFO?keyword=${self.keyword}&sdate=${self.date}&edate=${edate}&pz=${self.priceType == 0 ? '' : self.priceType}&pagenum=${self.pagenum}&pernum=${self.pernum}`,
                data: {},
                type: 'get',
                dataType: 'json',
                success: (res) => {
                    if (res.code == 'ok') {
                        self.msg_list = [];
                        self.totalNum = res.totalnum;
                        if (res.data.length > 0) {
                            let arr = [];
                            let dateArr = [];
                            res.data.forEach((item, index) => {
                                if (index == 0) {
                                    dateArr.push(item.sdate.substr(0, 10));
                                } else {
                                    const j = dateArr.length - 1;
                                    if (item.sdate.substr(0, 10) != dateArr[j]) {
                                        dateArr.push(item.sdate.substr(0, 10));
                                    }
                                }                                
                            })
                            dateArr.forEach((item, index) => {
                                let obj = {
                                    sdate: '',
                                    date: item,
                                    week: self.getWeek(item),
                                    list: []
                                }
                                res.data.forEach((cItem, cIndex) => {
                                    if (cItem.sdate.substr(0, 10) == item) {
                                        obj.sdate =  cItem.sdate;
                                        cItem.time = cItem.sdate.substr(11, 5);
                                        obj.list.push(cItem);
                                    }
                                })
                                arr.push(obj);
                            })
                            self.msg_list = arr;
                            self.totalNum = res.totalnum;
                        }
                        self.loading = false;
                    } else {
                        self.$message.error(res.message);
                        self.loading = false;
                    }
                },
                error: () => {
                    self.$message.error('未获取到报价信息')
                    self.loading = false;
                }
            })
        },

        // 查询用户定制的报价
        getSignTreeList () {
            const self = this;
            self.$get(`${baseUrl.crm}/business/cyw/openapi/getSignTreeList.json/${self.userInfo.id}`, {}).then(res => {
                if (res.code == 200) {
                    self.list_data = res.data;
                    if (res.data.length == 0) {
                        self.isShowDefault = true;
                    } else {
                        self.priceType = res.data[0]['groupPid'];
                        self.getMsgInfo();
                    }
                } else {
                    self.$message.error('查询分类信息失败');
                }
            }).catch(error => {
                self.$message.error('查询分类信息失败')
            })
        },

        // 跳转到报价定制：登录后才能用
        goCustomized () {
            this.token_cyw = this.$cookies.get('token_cyw');
            if (this.token_cyw) {
                this.getUserAllInfo(this.token_cyw, true);
            } else {
                this.$refs.loginDialog.init();
            }
        },
        // 切换类型
        changePriceParentType (type) {
            this.token_cyw = this.$cookies.get('token_cyw');
            this.isShowDefault = false;
            if (type == 1) {
                if (this.token_cyw) {
                    this.getUserAllInfo(this.token_cyw, false);
                } else {
                    this.$message({
                        message: '请登录后查看',
                        type: 'warning'
                    })
                }
            } else {
                this.priceParentType = type;
                this.getProductTreeList();
            }
        },

        // 获取用户信息
        getUserAllInfo (token_cyw, isJump) {
            if (token_cyw) {
                const self = this;
                self.$get(`${baseUrl.business}/api/user/userByToken/${token_cyw}`, {}).then(res_1 => {
                    if (res_1.status == 200) {
                        self.$get(`${baseUrl.business}/api/user/find/${res_1.data.id}`, {}).then(res => {
                            if(res.status == 200) {
                                if (res.data == null) {
                                    self.$message.error('未获取到身份信息')
                                } else {
                                    if (isJump) {
                                        self.$router.push({path: '/home/customized'})
                                    } else {
                                        self.userInfo = res.data;
                                        self.priceParentType = 1; // 切换tab
                                        self.getSignTreeList();
                                    }
                                }
                            } else {
                                self.$message.error('获取信息失败')
                            }
                        })
                    } else {
                        self.$confirm(res_1.msg, '提示', {
                            confirmButtonText: '确定',
                            showCancelButton: false,
                            type: 'error'
                        }).then(() => {
                            self.$router.go(0)
                        })
                    }
                }).catch(err_1 => {
                    self.$confirm('未获取到用户信息，请重新登录', '提示', {
                        confirmButtonText: '确定',
                        showCancelButton: false,
                        type: 'error'
                    }).then(() => {
                        self.$router.go(0)
                    })
                })
            } else {
                self.$message({
                    message: '请登录后查看',
                    type: 'warning'
                })
            }
        },

        changePriceType (type, name) {
            this.priceType = type;
            this.priceTypeName = name;
            this.keyword = '';
            this.date = '';
            this.pagenum = 1;
            this.pernum = 12;
            this.getMsgInfo();
        },

        showAllPriceParent (event) {
            const elem = $(event.target).parent();
            if (elem.height() == 20) {
                elem.animate({height: '100px'}, 'slow');
            } else {
                elem.animate({height: '20px'}, 'slow');
            }
        },

        /* 分页 */
        handleCurrentChange (index, event) {
            this.pagenum = index;
            this.getMsgInfo();
        },
        handleChangeSize (index) {
            this.pernum = index;
            this.getMsgInfo();
        },
        // 切换参数
        changeParam () {
            this.pagenum = 1;
            this.pernum = 12;
            this.getMsgInfo();
        },

        // 判断今天周几
        getWeek (date) {
            const new_date = new Date(date);
            const weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            const day = new_date.getDay();
            return weeks[day];
        },
    },
}
</script>

<style scoped>
    @import url('modifyPrice.css');
</style>